import { dataProps } from './properties'

export const setEStoreCategoryList = (state, payload) => {
    state.list = payload
}    

export const setEStoreCategoryData = (state, payload) => {
    state.props = payload
} 

export const resetEStoreCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCategory/mutations.js